// extracted by mini-css-extract-plugin
export default {"container":"CartFooter_container__ybm+z","cartText":"CartFooter_cartText__RzNb8"};